import * as React from "react";

const SvgUnrecess = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.36 22.057 1.883 1.659.472 3.076 3 5.594V13q0 1.65 1.175 2.825T7 17h6a4 4 0 0 0 1.257-.192l2.2 2.192H3v2h15.466l2.483 2.474zM12.442 15 5 7.587V13q0 .825.588 1.412Q6.175 15 7 15zM15 5v6.902l1.922 1.915A4.2 4.2 0 0 0 17 13v-3h2q.824 0 1.413-.588Q21 8.825 21 8V5q0-.824-.587-1.413A1.93 1.93 0 0 0 19 3H6.063l2.008 2zm2 3h2V5h-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnrecess;
